import { apiClient } from "@/api/apiClient";
import type {
	DtmOrthoImportAccepted,
	DtmOrthoImportBody,
} from "@/components/AddData/dtm-ortho/dtmOrtho.types";

/**
 * Accepts a DTM / ortho pair on v2-server (`POST /v2/api/:siteId/dtm-ortho`).
 * The server creates the point_cloud (PENDING) and drawing_2d (processing) rows in one transaction
 * and converts in the background; the caller tracks both rows. Non-2xx responses become an Error.
 *
 * @param siteId site UUID
 * @param body node references of both files, capture date / time and the import unit
 * @returns ids of the two created rows
 */
export const importDtmOrtho = async (
	siteId: string,
	body: DtmOrthoImportBody,
): Promise<DtmOrthoImportAccepted> => {
	const res = await apiClient.v2.api[":siteId"]["dtm-ortho"].$post({
		param: { siteId },
		json: body,
	});
	if (!res.ok) {
		throw new Error(`Failed to import DTM/ortho: ${res.status}`);
	}
	const { pointCloudId, drawing2dImageId } = await res.json();
	return { pointCloudId, drawing2dImageId };
};
